import { HelpCircle } from 'lucide-react'

interface DisabledTooltipProps {
  reason: string
  action?: string
  id?: string
}

export function DisabledTooltip({ reason, action, id }: DisabledTooltipProps) {
  return (
    <span className="relative group inline-block ml-1">
      <HelpCircle 
        className="w-4 h-4 text-gray-400 hover:text-gray-600 cursor-help" 
        aria-hidden="true"
      />
      <span 
        id={id}
        className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-3 py-2 z-50 max-w-xs break-words pointer-events-none"
        role="tooltip"
      >
        {reason}
        {action && <span className="block mt-1 text-gray-300 break-words">{action}</span>}
        <span className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-800"></span>
      </span>
    </span>
  )
}
